import type { Metadata } from "next";

import { NAKSHATRA_DATA, capitalize } from "./nakshatra-page-data";
import { rule76SnippetPatch } from "./rule76-snippet-patches";

import { OPEN_GRAPH_IMAGES } from "@/lib/seo/social-metadata";
export type Nakshatra = (typeof NAKSHATRA_DATA)[number];

export function publicNakshatraSlug(id: string): string {
  return id.replace(/_/g, "-");
}

export const NAKSHATRA_MAP = new Map(
  NAKSHATRA_DATA.flatMap((nakshatra) => [
    [nakshatra.id, nakshatra],
    [publicNakshatraSlug(nakshatra.id), nakshatra],
  ])
);

/**
 * Build metadata around the dominant "<name> nakshatra lord" intent while
 * allowing the evidence-bound rule-76 cohort to override an exact member.
 */
export function nakshatraRouteMetadata(nakshatra: Nakshatra): Metadata {
  const slug = publicNakshatraSlug(nakshatra.id);
  const governedSnippet = rule76SnippetPatch(`nakshatra/${slug}`);
  const title =
    governedSnippet?.title ??
    `${nakshatra.name_en} Nakshatra Lord: ${capitalize(nakshatra.ruler)} — Gana & Deity`;
  const description =
    governedSnippet?.meta ??
    `${nakshatra.name_en} nakshatra lord is ${capitalize(nakshatra.ruler)}, deity ${nakshatra.deity}, gana ${nakshatra.gana}. It sits in ${nakshatra.rashi_en} rashi, with all 4 padas and the personality traits this birth star gives.`;
  return {
    title,
    description,
    keywords: [
      `${nakshatra.name_en.toLowerCase()} nakshatra`,
      `${nakshatra.name_en.toLowerCase()} nakshatra meaning`,
      `${nakshatra.name_en.toLowerCase()} nakshatra lord`,
      `${nakshatra.name_en.toLowerCase()} nakshatra padas`,
      `${nakshatra.name_en.toLowerCase()} birth star`,
      `${nakshatra.name_hi} nakshatra`,
    ],
    alternates: { canonical: `https://ishvaram.com/nakshatra/${slug}/` },
    openGraph: {
      title,
      description,
      siteName: "Ishvaram",
      type: "website",
      images: OPEN_GRAPH_IMAGES,
    },
  };
}
